/* eslint-disable react/require-default-props */

import React from 'react';
import PropTypes from 'prop-types';
import { User } from '../../../CustomPropTypes/UserPropTypes';
import './CircleProfilePicture.scss';

// Wrap the component to inject dispatch and state into it
function CircleProfilePictureComponent({ imageUrl, altText, className }) {
  return (
    <circle-profile-picture class={className}>
      <span className="circle-profile-picture-avatar">
        <img
          className="circle-profile-picture-img"
          alt={altText}
          src={imageUrl}
        />
      </span>
    </circle-profile-picture>
  );
}

CircleProfilePictureComponent.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  className: PropTypes.string,
};

// optional 'user' prop that expands into the args we want
export function CircleProfilePicture(props) {
  const { user, ...otherProps } = props;
  let userProps = {};

  if (user) {
    userProps = {
      altText: user.fullName,
      imageUrl: user['avatar@3x'],
    };
  }

  return <CircleProfilePictureComponent {...userProps} {...otherProps} />;
}

CircleProfilePicture.propTypes = {
  user: User,
};
